// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home .intro {\n  padding-top: 45px;\n  padding-bottom: 45px;\n}\n.home .intro .searchBarParent {\n  padding: 5px;\n  display: flex;\n  align-items: center;\n}\n.home .intro .searchBarParent .searchBar {\n  margin-left: 10px;\n  flex: 1;\n}\n.home .intro .searchBarParent .searchBar input {\n  font-size: 20px;\n}\n.home .intro .searchBarParent .searchBtn {\n  padding: 10;\n}\n", ""]);
// Exports
module.exports = exports;
